/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 */
export interface HateoasLink { 
    /**
     * A link to the data.
     */
    readonly href?: string;
    /**
     * A relative link
     */
    readonly rel?: string;
    /**
     * A CSV list of the content types available from the endpoint, for the specific data set. When undefined the content type is deemed to be `application/json`.
     */
    readonly contentTypes?: string;
}

